function zoneChange(classList, zoneChoice) {
    if(zoneChoice === 1) {
        classList.add('PL1')
        classList.remove('PL2', 'PL3', 'zoneLottery', 'PL4', 'zoneNotSold', 'PL5','PL6', 'PL7', 'PL8', 'PL9', 'PL10', 'PL11')
    } else if(zoneChoice === 2) {
        classList.add('PL2')
        classList.remove('PL1', 'PL3', 'zoneLottery', 'PL4', 'zoneNotSold', 'PL5', 'PL6', 'PL7', 'PL8', 'PL9', 'PL10', 'PL11')
    } else if(zoneChoice === 3) {
        classList.add('PL3')
        classList.remove('PL1', 'PL2', 'zoneLottery', 'PL4', 'zoneNotSold', 'PL5', 'PL6', 'PL7', 'PL8', 'PL9', 'PL10', 'PL11')
    } else if(zoneChoice === 12) {
        classList.add('zoneLottery')
        classList.remove('PL1', 'PL2', 'PL3', 'PL4', 'zoneNotSold', 'PL5', 'PL6', 'PL7', 'PL8', 'PL9', 'PL10', 'PL11')
    } else if(zoneChoice === 4) {
        classList.add('PL4')
        classList.remove('PL1', 'PL2', 'PL3', 'zoneLottery', 'zoneNotSold', 'PL5', 'PL6', 'PL7', 'PL8', 'PL9', 'PL10', 'PL11')
    } else if(zoneChoice === 13) {
        classList.add('zoneNotSold')
        classList.remove('PL1', 'PL2', 'PL3', 'zoneLottery', 'PL4', 'PL5', 'PL6', 'PL7', 'PL8', 'PL9', 'PL10', 'PL11')
    } else if(zoneChoice === 5) {
        classList.add('PL5')
        classList.remove('PL1', 'PL2', 'PL3', 'zoneLottery', 'PL4', 'zoneNotSold', 'PL6', 'PL7', 'PL8', 'PL9', 'PL10', 'PL11')
    } else if(zoneChoice === 6) {
        classList.add('PL6')
        classList.remove('PL1', 'PL2', 'PL3', 'zoneLottery', 'PL4', 'zoneNotSold', 'PL5', 'PL7', 'PL8', 'PL9', 'PL10', 'PL11')
    } else if(zoneChoice === 7) {
        classList.add('PL7')
        classList.remove('PL1', 'PL2', 'PL3', 'zoneLottery', 'PL4', 'zoneNotSold', 'PL5', 'PL6', 'PL8', 'PL9', 'PL10', 'PL11')
    } else if(zoneChoice === 8) {
        classList.add('PL8')
        classList.remove('PL1', 'PL2', 'PL3', 'zoneLottery', 'PL4', 'zoneNotSold', 'PL5', 'PL6', 'PL7', 'PL9', 'PL10', 'PL11')       
    } else if(zoneChoice === 9) {
        classList.add('PL9')
        classList.remove('PL1', 'PL2', 'PL3', 'zoneLottery', 'PL4', 'zoneNotSold', 'PL5', 'PL6', 'PL7', 'PL8', 'PL10', 'PL11')
    } else if(zoneChoice === 10) {
        classList.add('PL10')
        classList.remove('PL1', 'PL2', 'PL3', 'zoneLottery', 'PL4', 'zoneNotSold', 'PL5', 'PL6', 'PL7', 'PL8', 'PL9', 'PL11' )
    } else if(zoneChoice === 11) {
        classList.add('PL11')
        classList.remove('PL1', 'PL2', 'PL3', 'zoneLottery', 'PL4', 'zoneNotSold', 'PL5', 'PL6', 'PL7', 'PL8', 'PL9', 'PL10')
    }
}

export default zoneChange